export default {
  signIn: 'Sign In',
  signOut: 'Sign Out',
  points: 'points',
  hyattSignInButton: 'Sign in to World of Hyatt',
};
